module.exports = "/images/marine-weather@3x.png?4dfd9f924dddaaf2436f3ff357afc93c";